import { render } from "./azulForm.vue?vue&type=template&id=30ad781d&scoped=true&ts=true"
import script from "./azulForm.vue?vue&type=script&lang=ts"
export * from "./azulForm.vue?vue&type=script&lang=ts"

import "./azulForm.vue?vue&type=style&index=0&id=30ad781d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ad781d"]])

export default __exports__